import axios from "axios";
import { propertyAPI } from "../../axios";
import { PropertyAPI } from "../../axios";

export const actions = {
  //Property
  GetPropertyPending(context, data) {
    return propertyAPI.get(`Property/All/Pending/${data}`);
  },
  GetPropertyAvailable(context, data) {
    return propertyAPI.get(`Property/Available/${data}`);
  },
  GetPropertyPosted(context, data) {
    return propertyAPI.get(`Property/All/Posted/${data}`);
  },
  GetPropertyForDisposal(context, data) {
    return propertyAPI.get(`Property/All/ForDisposal/${data}`);
  },
  GetPropertyDisposed(context, data) {
    return propertyAPI.get(`Property/All/Disposed/${data}`);
  },
  GetSingleProperty(context, data) {
    return propertyAPI.get(`Property/${data}`);
  },
  GetPropertybyPO(context, data) {
    return axios.post(`property/Property/PoNumber/${data.campusId}`, data);
  },
  GetPropertybySearch(context, data) {
    return propertyAPI.post(`Property/Filter`, data);
  },
  GetPropertybyAccountableOfficer(context, data) {
    return propertyAPI.get(`Property/AccountableOfficer/Public/${data}`);
  },
  GetExpiredProperties(context, data) {
    return propertyAPI.get(`Property/Expired/${data}`);
  },
  UpdateProperty(context, data) {
    return propertyAPI.put(`Property/${data.id}`, data);
  },
  DeleteProperty(context, data) {
    return propertyAPI.delete(`Property/${data}`);
  },
  CreateProperty(context, data) {
    return propertyAPI.post(`Property/Create/${data.campusId}`, data);
  },
  CreatePropertyMultiple(context, data) {
    return propertyAPI.post(`Property/multiple/Create/${data.campusId}`, data.data);
  },
  PostProperty(context, data) {
    return propertyAPI.put(`Property/post/${data}`, data);
  },
  PostMultipleProperty(context, data) {
    return propertyAPI.put(`Property/Post/Multiple`, data);
  },
  ReturnProperty(context, data) {
    return propertyAPI.put(`Property/return/${data}`, data);
  },
  UnDisposeProperty(context, data) {
    return propertyAPI.put(`Property/UnDispose/${data}`, data);
  },
  DisposalMultipleProperty(context, data) {
    return propertyAPI.put(`Property/Disposal/Multiple`, data);
  },
  DisposeMultipleProperty(context, data) {
    return propertyAPI.put(`Property/Dispose/Multiple`, data);
  },
  UpdateAccountableOfficer(context, data) {
    return PropertyAPI.put(`AccountableOfficer/${data}`);
  },
  PropertyUploadImage(context, data) {
    return propertyAPI.post(`Property/File/Upload/${data.id}`, data);
  },
  PropertyTransfer(context, data) {
    return propertyAPI.post(`Property/Transfer`, data);
  },
  ChangeCategory(context, data) {
    return propertyAPI.put(`Property/ChangeCategory`, data);
  },
  updateDateAcquired(context, data) {
    return propertyAPI.put(`Property/Update/Multiple/Date`, data);
  },
  updateUnitCost(context, data) {
    return propertyAPI.put(`Property/Update/Multiple/UnitCost`, data);
  },
  updateCondition(context, data) {
    return propertyAPI.put(`Property/Update/Multiple/Condition`, data);
  },
  updateNote(context, data) {
    return propertyAPI.put(`Property/Update/Multiple/Note`, data);
  },
};
